import { Button } from '@mui/material';
import React from 'react';
import GoogleIcon from '@mui/icons-material/Google';
import { auth, provider, signInWithPopup, signCustomToken } from '../utils/firebase';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import userService from '../user.service';

const LoginWithGoogle = () => {
  const history = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const idToken = await user.getIdToken();

      const { data } = await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/socialSignin`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: idToken,
          },
        },
      );
      const loginData = data?.data || null;
      console.log('🔍 LoginWithGoogle Response:', loginData);

      if (loginData?.user) {
        userService.updateAuthData({
          accessToken: loginData.id,
          currentUserId: loginData.userId,
          rememberMe: true,
        });

        userService.updateStorage({
          accessToken: loginData.id,
          currentUserId: loginData.userId,
          rememberMe: true,
        });

        userService.updateCurrentUser(loginData.user);
        localStorage.setItem('auth', loginData.id + '~29#215@rfeqwEt0');

        // Save refresh token if available
        if (loginData.refreshToken) {
          localStorage.setItem('refreshToken', loginData.refreshToken);
          sessionStorage.setItem('refreshToken', loginData.refreshToken);
          console.log('✅ LoginWithGoogle: Refresh token saved');
        } else {
          console.log('⚠️ LoginWithGoogle: No refresh token in response');
        }

        // Sign in with Firebase custom token if available
        if (loginData.firebaseCustomToken) {
          try {
            const response = await signCustomToken(loginData.firebaseCustomToken);
            if (response?.user?.uid) {
              console.log('✅ LoginWithGoogle: Firebase sign-in successful, UID:', response.user.uid);
            }
          } catch (error) {
            console.error('⚠️ LoginWithGoogle: Firebase sign-in error:', error);
          }
        } else {
          console.log('⚠️ LoginWithGoogle: No Firebase token provided');
        }

        history('/main');
      }
    } catch (error) {
      console.error('Error signing in with Google:', error);
    }
  };

  return (
    <Button variant="outlined" onClick={handleGoogleSignIn} color="primary">
      <GoogleIcon style={{ marginRight: '10px', padding: '6px', color: '#3F50B5' }} /> Continue with Google
    </Button>
  );
};

export default LoginWithGoogle;
